<!-- 主页 -->
<template>
    <div id="index" ref="appRef">
        <div class="main">
            <!-- 顶部栏 -->
            <div class="main_top">
                <div class="t-nam">
                    <div v-if="selectFlag == false">{{ projectData.name }}</div>
                    <div v-else>
                        <el-select style="width: 330px;" v-model="projectName" placeholder="请选择"
                            @change="changeProject">
                            <el-option v-for="item in projectList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <!-- <img src="../assets/newimgs/zh-name.png"> -->
                </div>
                <div class="t-title">智慧农业</div>
                <div class="t-right">
                    <!-- <img src="../assets/newimgs/tianqi.png"> -->
                    <div>
                        <i :class="weatherData.icon"></i>
                        <span class="num">{{ weatherData.temp }}</span>
                        <span class="unit">℃</span>
                    </div>
                    <div class="address">{{ weatherData.text }} {{ projectData.cityName }}</div>
                    <div class="feng" v-if="weatherData.windDir">{{ weatherData.windDir }}</div>
                </div>
            </div>
            <!-- 内容 -->
            <div class="count">
                <div class="count-top">
                    <div class="c-left">
                        <div style="width: 90px;">温室选择：</div>
                        <div class="c-select" @click="wsIsShow = true">
                            <div class="inner-select">
                                <div class="ws-name">{{ wsName || '请选择' }}</div>
                                <div class="s-list" v-if="wsIsShow">
                                    <div class="s-item" v-for="item in wsList" :key="item.deviceId"
                                        @click.stop="selectClick(item)">
                                        {{ item.name }}
                                    </div>
                                </div>
                            </div>
                            <!-- <el-select style="flex:1;width: 100%;" size="small" v-model="wsValue" placeholder="请选择"
                                @change="wschange">
                                <el-option v-for="item in wsList" :key="item.deviceId" :label="item.name"
                                    :value="item.deviceId">
                                </el-option>
                            </el-select> -->
                        </div>
                    </div>
                    <div class="c-right">
                        <div class="r-item" :class="active == 1 ? 'active-item' : ''" @click="tableClick('1')">温室环境信息
                        </div>
                        <div class="r-item" :class="active == 2 ? 'active-item' : ''" @click="tableClick('2')">虫情监测
                        </div>
                        <div class="r-item" :class="active == 3 ? 'active-item' : ''" @click="tableClick('3')">水肥一体化
                        </div>
                    </div>
                </div>
                <div class="count-count" v-show="active == 1"
                    style="padding: 138px 88px 0 88px;box-sizing: border-box;">
                    <div class="c-item">
                        <div class="i-top">
                            <img src="../assets/newimgs/zh-icon.png">
                            温度
                        </div>
                        <div class="i-bottom">
                            <div class="img"><img src="../assets/newimgs/shidu.png"></div>
                            <div class="i-count">
                                <div class="wendu">{{ temperatureNum || '23' }}<span>℃</span></div>
                                <div class="i-title">降温状态：</div>
                                <div class="text">{{ temperatureStatus || '在阳光的湿暖下，大部地区最高气湿和前天相比，都升高了2-6℃' }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="c-item">
                        <div class="i-top">
                            <img src="../assets/newimgs/zh-icon.png">
                            湿度
                        </div>
                        <div class="i-bottom">
                            <div class="img"><img src="../assets/newimgs/wendu.png"></div>
                            <div class="i-count">
                                <div class="wendu">{{ humidityNum || '7' }}<span>%</span></div>
                                <div class="i-title">除湿状态：{{ humidityStatus }}</div>
                                <div class="text">除湿温度计值：{{ relativeHumidity }}%</div>
                            </div>
                        </div>
                    </div>
                    <div class="c-item">
                        <div class="i-top">
                            <img src="../assets/newimgs/zh-icon.png">
                            开窗
                        </div>
                        <div class="i-bottom">
                            <div class="img"><img src="../assets/newimgs/kaichuang.png"></div>
                            <div class="i-count">
                                <div class="i-item" v-for="(item, index) in openWindowList" :key="index">
                                    <span>{{ item.N }}:</span>
                                    <el-progress class="num" :percentage="item.V * 1" :stroke-width="16" color="#fff"
                                        text-color="#fff" define-back-color="rgba(0, 0, 0, 0.4)"></el-progress>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c-item">
                        <div class="i-top">
                            <img src="../assets/newimgs/zh-icon.png">
                            降温设备 {{ coolStatus }}
                        </div>
                        <div class="i-bottom">
                            <div class="img"><img src="../assets/newimgs/shebei.png"></div>
                            <div class="i-count">
                                <div class="i-item" v-for="(item, index) in coolList" :key="index">
                                    {{ item.N }}：{{ item.S }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c-item">
                        <div class="i-top">
                            <img src="../assets/newimgs/zh-icon.png">
                            帘幕
                        </div>
                        <div class="i-bottom">
                            <div class="img"><img src="../assets/newimgs/lianmu.png"></div>
                            <div class="i-count">
                                <div class="i-item" v-for="(item, index) in curtainList" :key="index">
                                    <span>{{ item.N }}:</span>
                                    <el-progress class="num" :percentage="item.V" :stroke-width="16" color="#fff"
                                        text-color="#fff" define-back-color="rgba(0, 0, 0, 0.4)"></el-progress>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="c-item">
                        <div class="i-top">
                            <img src="../assets/newimgs/zh-icon.png">
                            单点设备状态
                        </div>
                        <div class="i-bottom">
                            <div class="img"><img src="../assets/newimgs/zhuangtai.png"></div>
                            <div class="i-count">
                                <div class="i-item" v-for="(item, index) in customList" :key="index">
                                    {{ item.N }}：{{ item.S }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="count-count" v-show="active == 2" style="color: #fff;padding: 107px 88px 0 88px;box-sizing: border-box;
                    ">
                    <div class="er-item">
                        <div class="c-top">
                            <div class="t-left">
                                <img src="../assets/newimgs/cq-i-img.png">
                                设备信息
                            </div>
                            <div class="t-right" v-if="equipmentData">
                                <el-select style="width: 130px;" v-model="equipmentName" placeholder="请选择"
                                    @change="changeEquipment">
                                    <el-option v-for="item in equipmentList" :key="item.deviceId" :label="item.name"
                                        :value="item.deviceId">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="c-bottom" v-if="equipmentData">
                            <div class="c-b-item">
                                <div class="sb-title">设备ID：</div>
                                <div class="sb-zhi">{{ equipmentData.deviceId }}</div>
                            </div>
                            <div class="c-b-item">
                                <div class="sb-title">设备名称：</div>
                                <div class="sb-zhi">{{ equipmentData.name }}</div>
                            </div>
                            <div class="c-b-item">
                                <div class="sb-title">设备状态：</div>
                                <div class="sb-zhi">{{ equipmentData.ws == 0 ? "离线" : "在线" }}</div>
                            </div>
                            <div class="c-b-item">
                                <div class="sb-title">设备定位：</div>
                                <div class="sb-zhi">{{ equipmentData.address }}</div>
                            </div>
                            <div class="c-b-item">
                                <div class="sb-title">最新上报时间：</div>
                                <div class="sb-zhi">{{ equipmentData.newUploadTime }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="er-item">
                        <div class="c-top">
                            <div class="t-left">
                                <img src="../assets/newimgs/cq-i-img.png">
                                环境温度湿度
                            </div>
                        </div>
                        <div class="c-bottom" style="width: 470px;">
                            <cqLeftEchats2 ref="echartsRef2" :deviceId="deviceId" />
                        </div>
                    </div>
                    <div class="er-item">
                        <div class="c-top">
                            <div class="t-left">
                                <img src="../assets/newimgs/cq-i-img.png">
                                虫情趋势
                            </div>
                        </div>
                        <div class="c-bottom" style="width: 470px;">
                            <cqLeftEchats3 ref="echartsRef3" :deviceId="deviceId" />
                        </div>
                    </div>
                    <div class="er-item">
                        <div class="c-top">
                            <div class="t-left">
                                <img src="../assets/newimgs/cq-i-img.png">
                                虫情走势信息
                            </div>
                            <div class="t-right">
                                <el-select style="width: 130px;" v-model="badInsect" placeholder="请选择" @change="change">
                                    <el-option v-for="(item, index) in datalist" :key="index" :label="item.pestName"
                                        :value="item.pestName">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="c-bottom">
                            <div class="inner-bottom">
                                <div class="zs-item">
                                    <div class="zs-i-img"><img src="../assets/newimgs/yi.png" /></div>
                                    <div class="i-time">{{ seeTime }}</div>
                                    <div class="i-text">始见期</div>
                                    <div class="i-num"> </div>
                                </div>
                                <div class="zs-img">
                                    <img src="../assets/newimgs/jindu.png" />
                                </div>
                                <div class="zs-item">
                                    <div class="zs-i-img"><img src="../assets/newimgs/er.png" /></div>
                                    <div class="i-time">{{ fastigiumTime }}</div>
                                    <div class="i-text">高峰期</div>
                                    <div class="i-num">{{ fastigiumNum }}头</div>
                                </div>
                                <div class="zs-img">
                                    <img src="../assets/newimgs/jindu.png" />
                                </div>
                                <div class="zs-item">
                                    <div class="zs-i-img"><img src="../assets/newimgs/san.png" /></div>
                                    <div class="i-time">{{ endTime }}</div>
                                    <div class="i-text">终见期</div>
                                    <div class="i-num"> </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="er-item">
                        <div class="c-top">
                            <div class="t-left">
                                <img src="../assets/newimgs/cq-i-img.png">
                                害虫占比
                            </div>
                        </div>
                        <div class="c-bottom" style="width: 470px;">
                            <cqRightEchats2 ref="echartsRef5" :deviceId="deviceId" />
                        </div>
                    </div>
                    <div class="er-item">
                        <div class="c-top">
                            <div class="t-left">
                                <img src="../assets/newimgs/cq-i-img.png">
                                害虫排名
                            </div>
                        </div>
                        <div class="c-bottom" style="width: 470px;">
                            <cqRightEchats3 ref="echartsRef6" :deviceId="deviceId" />
                        </div>
                    </div>
                </div>
                <div class="count-count" v-show="active == 3" style="padding: 15px 5px 0 5px;box-sizing: border-box;">
                    <div class="item-left">
                        <div class="san-item san1">
                            <div class="c-top">
                                <div class="t-left">
                                    <img src="../assets/newimgs/cq-i-img.png">
                                    项目信息
                                </div>
                            </div>
                            <div class="c-bottom">
                                <div class="c-b-item">
                                    <div class="sb-title">项目名称：</div>
                                    <div class="sb-zhi">{{ objData.name }}</div>
                                </div>
                                <div class="c-b-item">
                                    <div class="sb-title">项目编号：</div>
                                    <div class="sb-zhi">{{ objData.code }}</div>
                                </div>
                                <div class="c-b-item">
                                    <div class="sb-title">客户名称：</div>
                                    <div class="sb-zhi">{{ objData.clientName }}</div>
                                </div>
                                <div class="c-b-item">
                                    <div class="sb-title">公司名称：</div>
                                    <div class="sb-zhi">{{ objData.companyName }}</div>
                                </div>
                                <div class="c-b-item">
                                    <div class="sb-title">联系人：</div>
                                    <div class="sb-zhi">{{ objData.contact }}</div>
                                </div>
                                <div class="c-b-item">
                                    <div class="sb-title">联系电话：</div>
                                    <div class="sb-zhi">{{ objData.contactPhone }}</div>
                                </div>
                                <div class="c-b-item">
                                    <div class="sb-title">详细地址：</div>
                                    <div class="sb-zhi">{{ objData.address }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="san-item san2">
                            <div class="c-top">
                                <div class="t-left">
                                    <img src="../assets/newimgs/cq-i-img.png">
                                    气象土壤信息
                                </div>
                            </div>
                            <div class="c-bottom">
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/wendu.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">空气温度</div>
                                        <div class="qx-zhi">{{ wfQxInfo.at }}℃</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/shidu.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">空气湿度</div>
                                        <div class="qx-zhi">{{ wfQxInfo.ah }}%RH</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/qiya.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">气压</div>
                                        <div class="qx-zhi">{{ wfQxInfo.sap }}hpa</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/fengxiang.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">风向</div>
                                        <div class="qx-zhi">{{ wfQxInfo.wd }}°</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/fengsu.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">风速</div>
                                        <div class="qx-zhi">{{ wfQxInfo.ws }}m/s</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/leiji.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">降雨量累计</div>
                                        <div class="qx-zhi">{{ wfQxInfo.rfa }}mm</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/zhaodu.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">光照度</div>
                                        <div class="qx-zhi">{{ wfQxInfo.ioi }}LUX</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/fushe.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">总辐射</div>
                                        <div class="qx-zhi">{{ wfQxInfo.str }}w/㎡</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/g-fushe.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">光合有效辐射</div>
                                        <div class="qx-zhi">{{ wfQxInfo.par }}W/㎡</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/shi.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">日照时数</div>
                                        <div class="qx-zhi">{{ wfQxInfo.sh }}h</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/er.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">二氧化碳</div>
                                        <div class="qx-zhi">{{ wfQxInfo.co2 }}PPM</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/turang.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">土壤温度</div>
                                        <div class="qx-zhi">{{ wfQxInfo.st }}℃</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="san-item san3">
                            <div class="c-top">
                                <div class="t-left">
                                    <img src="../assets/newimgs/cq-i-img.png">
                                    温室气象信息
                                </div>
                            </div>
                            <div class="c-bottom">
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/wendu.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">空气温度</div>
                                        <div class="qx-zhi">{{ modelInfo[0] }}℃</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/shidu.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">空气温湿度</div>
                                        <div class="qx-zhi">{{ modelInfo[1] }}%RH</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/zhaodu.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">光照强度</div>
                                        <div class="qx-zhi">{{ modelInfo[2] }}hpa</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/fengxiang.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">风向</div>
                                        <div class="qx-zhi">{{ modelInfo[4] }}°</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/fengsu.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">风速</div>
                                        <div class="qx-zhi">{{ modelInfo[3] }}m/s</div>
                                    </div>
                                </div>
                                <div class="qx-item">
                                    <div class="i-img"><img src="../assets/newimgs/shuifei/jiangyu.png" /></div>
                                    <div class="qx-right">
                                        <div class="qx-title">降雨状态</div>
                                        <!-- mm -->
                                        <div class="qx-zhi">{{ modelInfo[5] == 0 ? '无' : '有' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item-count">
                        <div class="big" v-if="videoList && videoList[0]">
                            <div class="big-img" @click="videoClick(videoList[0])">
                                <img :src="videoList[0].coverPicture" alt="">
                            </div>
                            <div class="tip">
                                <div class="t-item">
                                    <div class="t-img">
                                        <img style="width: 15px;height: 15px;margin-bottom: 2px;"
                                            src="../assets/newimgs/shuifei/name.png" />
                                    </div>
                                    <div class="tip-title">设备名称</div>
                                    <div class="t-zhi">{{ videoList[0].name }}</div>
                                </div>
                                <div class="t-item">
                                    <div class="t-img" style="margin-right: -2px;">
                                        <img style="width: 12px;height: 15px;margin-bottom: 2px;"
                                            src="../assets/newimgs/shuifei/address.png" />
                                    </div>
                                    <div class="tip-title">设备位置</div>
                                    <div class="t-zhi">{{ videoList[0].name }}</div>
                                </div>
                                <div class="t-item">
                                    <div class="t-img">
                                        <img style="width: 18px;height: 18px;margin-bottom: 2px;"
                                            src="../assets/newimgs/shuifei/type.png" />
                                    </div>
                                    <div class="tip-title">设备类型</div>
                                    <div class="t-zhi">{{ videoList[0].deviceSerial }}</div>
                                </div>
                                <div class="t-item">
                                    <div class="t-img">
                                        <img style="width: 17px;height: 17px;margin-bottom: 2px;"
                                            src="../assets/newimgs/shuifei/status.png" />
                                    </div>
                                    <div class="tip-title">设备状态</div>
                                    <div class="t-zhi">正常</div>
                                </div>
                            </div>
                        </div>
                        <div class="small" v-if="videoList && videoList.length > 0">
                            <div class="small_img" v-for="(item, index) in videoList" :key="index"
                                @click="videoClick(item)">
                                <div class="s-img"><img v-if="item.coverPicture" :src="item.coverPicture" alt=""></div>
                                <div class="s-item">
                                    <div class="s-left">设备名称：</div>
                                    <div class="s-right">{{ item.name || "" }}</div>
                                </div>
                                <div class="s-item">
                                    <div class="s-left">设备状态：</div>
                                    <div class="s-right">在线</div>
                                </div>
                                <div class="s-item">
                                    <div class="s-left">设备位置：</div>
                                    <div class="s-right">{{ item.name || "" }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item-right">
                        <div class="san-item right1">
                            <div class="c-top">
                                <div class="t-left">
                                    <img src="../assets/newimgs/cq-i-img.png">
                                    不同生长期作物数据
                                </div>
                            </div>
                            <div class="c-bottom">
                                <div class="r-c-item" v-for="(item, index) in tendencyList" :key="index">
                                    <div class="c-i-num">{{ item.cropNum }}</div>
                                    <div class="c-i-text">{{ item.grwothName }}</div>
                                </div>
                                <!-- <div class="r-c-item">
                                <div class="c-i-num">24</div>
                                <div class="c-i-text">坐果期</div>
                            </div> -->
                            </div>
                        </div>
                        <div class="san-item right2">
                            <div class="c-top">
                                <div class="t-left">
                                    <img src="../assets/newimgs/cq-i-img.png">
                                    气象趋势数据
                                </div>
                            </div>
                            <div class="c-bottom" style="margin-top: 20px;height: 270px;">
                                <div id="right2" style="width:100%;height: 270px;"></div>
                            </div>
                        </div>
                        <div class="san-item right3">
                            <div class="c-top">
                                <div class="t-left">
                                    <img src="../assets/newimgs/cq-i-img.png">
                                    土壤数据趋势
                                </div>
                            </div>
                            <div class="c-bottom" style="margin-top: 20px;height: 270px;">
                                <div id="right3" style="width:100%;height: 270px;"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 视屏播放弹窗 -->
            <videoPlay ref="liveVideoDetail" />
        </div>
    </div>

</template>

<script>
import * as echarts from 'echarts'
import { formatTime } from '@/utils/index'
import drawMixin from "@/utils/drawMixin"
import { getProject, getWeather, getSoli_weather, getWsList, getCQ_equipment, getCQ_tendency, getQX_listMonitoring, getQX_projectInfo, getQX_wfQxInfo, getQX_modelInfo, getQX_cropGrowth, getQX_weatherSoilTrend } from '../api/api'
import cqLeftEchats2 from "../components/echart/cqLeftEchats2.vue"
import cqLeftEchats3 from "../components/echart/cqLeftEchats3.vue"
import cqRightEchats2 from "../components/echart/cqRightEchats2.vue"
import cqRightEchats3 from "../components/echart/cqRightEchats3.vue"
import videoPlay from "../components/videoPlay.vue"

export default {
    mixins: [drawMixin],
    components: {
        cqLeftEchats2,
        cqLeftEchats3,
        cqRightEchats2,
        cqRightEchats3,
        videoPlay
    },
    data() {
        return {
            active: 1,
            value: [new Date(8, 40), new Date(9, 40)],
            projectId: "",
            // 温室选择
            wsList: [{ name: "111", deviceId: 1 }, { name: "222", deviceId: 2 }],
            wsValue: "",
            wsName: "",
            wsIsShow: false,
            // 查询参数
            query: {
                deviceId: "19221015606",  //温室设备ID
                zoneId: "0",    //区域序号
            },
            // 温度显示
            temperatureNum: "",      //温度值
            temperatureStatus: "",   //降温状态
            // 湿度显示
            humidityNum: "",         //湿度
            humidityStatus: "",      //除湿状态
            relativeHumidity: "",    //除湿温度计值
            // 开窗显示
            openWindowList: [],
            // 降温设备显示
            coolStatus: "",          //设备状态
            coolList: [],            //设备列表
            // 帘幕展示
            curtainList: [],         //帘幕列表
            // 单点设备展示
            customList: [],
            // 项目信息
            projectData: {},
            projectName: "",
            lng: "",
            lat: "",
            weatherData: {},
            // 下拉框
            projectList: [],
            selectFlag: false,
            equipmentData: {},
            equipmentList: [],
            equipmentName: "",
            deviceId: "",
            // 标题栏选择
            radio1: '害虫迁徙图',
            // 年份选择
            year: "2023",
            // 害虫分类列表
            insectType: "",
            insectTypeList: [
                { value: '选项1', label: '一点金刚钻' },
                { value: '选项2', label: '东方粘虫' },
                { value: '选项3', label: '丝棉木金星大尺蛾' },
                { value: '选项4', label: '丝棉木尺蛾' },
                { value: '选项5  ', label: '丝棉木金星尺蛾' },
            ],
            // 虫情时期选择
            stage: "",
            badInsect: "",
            // 数据展示
            datalist: {},
            seeTime: "",         //始见期
            fastigiumTime: "",   //高峰期
            fastigiumNum: "",    //高峰期数量
            endTime: "",         //终见期
            cqquery: {
                deviceId: "19221015606",  //设备id
                beginTime: "",            //开始时间 
                endTime: "",              //结束时间 
            },
            // headUrl: "https://web.cewud-agrinet.com",
            headUrl: 'https://cewud-agrinet.qixiuu.com',
            videoList: [],
            objData: {},
            wfQxInfo: {},
            query3: {
                deviceId: "19221015606",  //温室设备ID
                modelId: "21",   //模块ID
                zoneId: "0",    //区域序号
            },
            modelInfo: [],
            ghData: [],    // 光合有效辐射数据
            gzdData: [],   // 光照度数据
            dqylData: [],  // 大气压力数据
            kqwdData: [],  // 空气温度数据
            kqsdData: [],  // 空气湿度数据
            ylData: [],    // 雨量数据
            query4: {
                projectId: "1622845821245853697",
                startTime: "2023",
                endTime: "2023",
            },
            query5: {
                projectId: "1622845821245853697",
                cropId: "",
                startTime: "",
                endTime: "",
            },
            tendencyList: [],
            trssData: [],  // 土壤水势数据
            trwdData: [],  // 土壤温度数据
            trsdData: [],  // 土壤湿度数据
        }
    },
    created() {
        this.cancelLoading()
        this.getProject()
        // this.projectId = '1621395311428218882'
        this.projectId = JSON.parse(localStorage.getItem("projectId"))
        if (this.projectId) {
            if (this.active == 1) {
                this.getWslist(this.projectId)
            } else if (this.active == 2) {
                this.getEquipment(this.projectId)
                setTimeout(() => {
                    // this.$refs.echartsRef2.query.imei = '19221015699'
                    this.$refs.echartsRef2.getData()
                    // this.$refs.echartsRef3.query.deviceId = '19221015699'
                    this.$refs.echartsRef3.getData()
                    // this.$refs.echartsRef5.query.deviceId = '19221015699'
                    this.$refs.echartsRef5.getData()
                    // this.$refs.echartsRef6.query.deviceId = '19221015699'
                    this.$refs.echartsRef6.getData()
                }, 800)
            } else if (this.active == 3) {
                this.getQXmodelInfo()
                this.getVideoList(this.projectId)
                this.getQXprojectInfo(this.projectId)
                this.getQXwfQxInfo(this.projectId)
                this.getQXcropGrowth(this.projectId)
                this.getQXweatherSoilTrend(this.projectId)
            }
        }
    },
    mounted() {
        let _this = this
        window.addEventListener('setItemEvent', (e) => {
            _this.changeData(e)
            const newdata = JSON.parse(e.newValue)
            if (this.active == 1) {
                _this.getWslist(newdata)
            } else if (this.active == 2) {
                _this.getEquipment(newdata)
            } else if (this.active == 3) {
                _this.getQXmodelInfo()
                _this.getVideoList(newdata)
                _this.getQXprojectInfo(newdata)
                _this.getQXwfQxInfo(newdata)
                _this.getQXcropGrowth(newdata)
                _this.getQXweatherSoilTrend(newdata)
            }
        })
    },
    destroyed() {
        // 移除绑定的事件监听
        window.removeEventListener("setItemEvent", (e) => {
            this.changeData(e)
        })
    },
    methods: {
        tableClick(val) {
            this.active = val
            if (this.active == 1) {
                this.getWslist(this.projectId)
            } else if (this.active == 2) {
                this.getEquipment(this.projectId)
                setTimeout(() => {
                    // this.$refs.echartsRef2.query.imei = '19221015699'
                    this.$refs.echartsRef2.getData()
                    // this.$refs.echartsRef3.query.deviceId = '19221015699'
                    this.$refs.echartsRef3.getData()
                    // this.$refs.echartsRef5.query.deviceId = '19221015699'
                    this.$refs.echartsRef5.getData()
                    // this.$refs.echartsRef6.query.deviceId = '19221015699'
                    this.$refs.echartsRef6.getData()
                }, 800)
            } else if (this.active == 3) {
                this.getQXmodelInfo()
                this.getVideoList(this.projectId)
                this.getQXprojectInfo(this.projectId)
                this.getQXwfQxInfo(this.projectId)
                this.getQXcropGrowth(this.projectId)
                this.getQXweatherSoilTrend(this.projectId)
            }
        },
        selectClick(item) {
            this.wsName = item.name
            this.wsValue = item.deviceId
            this.tableClick(this.active)
            this.wsIsShow = false
        },
        wschange() {
            this.tableClick(this.active)
        },
        // 获取项目信息
        async getProject() {
            let res = await getProject()
            if (res.code == 200) {
                this.projectData = res.data[0]
                this.projectList = res.data
                this.projectName = this.projectData.name
                window.localStorage.setItem('projectId', JSON.stringify(res.data[0].id))
                if (res.data.length <= 1) {
                    this.selectFlag = false
                } else {
                    this.selectFlag = true
                }
                this.lat = res.data[0].latitude
                this.lng = res.data[0].longitude
                this.getWeather()
            }
        },

        // 获取天气信息
        async getWeather() {
            let res = await getWeather({
                location: this.lng + "," + this.lat,
                type: 0
            })
            if (res.code == 200) {
                this.weatherData = res.data.now
                this.weatherData.icon = 'qi-' + this.weatherData.icon
            }
        },

        // 切换项目信息
        changeProject(e) {
            // localStorage.setItem('projectId', e)
            window.localStorage.setItem('projectId', JSON.stringify(e))
            this.projectList.forEach(item => {
                if (item.id == e) {
                    this.projectData = item
                    this.lat = item.latitude
                    this.lng = item.longitude
                    this.getWeather()
                }
            })
            this.tableClick(this.active)
            // this.$router.go(1)
        },
        // 获取设备信息
        async getEquipment(projectId) {
            let res = await getCQ_equipment({
                projectId,
            })
            if (res.code == 200) {
                this.equipmentList = res.data
                this.equipmentData = res.data[0]
                this.equipmentName = res.data ? res.data[0].name : ""
                this.deviceId = res.data[0].deviceId
                this.getTendency()
                // window.localStorage.setItem('deviceId', JSON.stringify(res.data[0].deviceId))
            }
        },
        // 切换设备
        changeEquipment(e) {
            this.deviceId = e
            this.equipmentList.forEach(item => {
                if (item.deviceId == e) {
                    this.equipmentData = item
                }
            })
        },
        // 选择环境温度湿度时间
        chooseWeatherTime(e) {
            window.localStorage.setItem('deviceId', JSON.stringify(e))
        },
        cancelLoading() {
            setTimeout(() => {
                this.loading = false
            }, 500)
        },
        // 改变数据
        changeData(e) {
            const newdata = JSON.parse(e.newValue)
            this.getWslist(newdata)
        },
        // 获取数据
        async getData() {
            let res = await getSoli_weather({
                ...this.query
            })
            if (res.code == 200) {
                res.data.forEach(item => {
                    if (item.modelName == "温度") {
                        this.temperatureNum = item.data.V
                        this.temperatureStatus = item.data.S
                    }
                    if (item.modelName == "湿度") {
                        this.humidityNum = item.data.V
                        this.humidityStatus = item.data.S
                        this.relativeHumidity = item.data.C
                    }
                    if (item.modelName == "开窗") {
                        this.openWindowList = item.data
                    }
                    if (item.modelName == "降温设备") {
                        this.coolList = item.data
                        this.coolStatus = this.coolList.every(item => item.ON == false) ? "未运行" : "运行中"
                    }
                    if (item.modelName == "帘幕") {
                        this.curtainList = item.data
                    }
                    if (item.modelName == "自定义设备") {
                        this.customList = item.data
                    }
                })
            }
        },
        // 获取温室选项
        async getWslist(projectId) {
            let res = await getWsList({
                projectId,
            })
            if (res.code == 200 && res.data) {
                // this.wsList = res.data
                this.wsValue = res.data[0].name
                this.query.deviceId = res.data[0].deviceId
                this.getData()
            }
        },
        // 获取数据
        async getTendency() {
            this.cqquery.deviceId = this.deviceId
            let res = await getCQ_tendency({
                ...this.cqquery
            })
            if (res.code == 200) {
                this.datalist = res.data
                this.badInsect = res.data[0].pestName
                this.seeTime = formatTime(res.data[0].minDate, 'yyyy-MM-dd')
                this.fastigiumTime = formatTime(res.data[0].minDate, 'yyyy-MM-dd')
                this.endTime = formatTime(res.data[0].minDate, 'yyyy-MM-dd')
                this.fastigiumNum = res.data[0].heightCount
            }
        },
        change(e) {
            this.datalist.forEach(item => {
                if (item.pestName == e) {
                    this.seeTime = formatTime(item.minDate, 'yyyy-MM-dd')
                    this.fastigiumTime = formatTime(item.minDate, 'yyyy-MM-dd')
                    this.endTime = formatTime(item.minDate, 'yyyy-MM-dd')
                    this.fastigiumNum = item.heightCount
                }
            })
        },
        // 获取监控视屏信息
        async getVideoList(projectId) {
            let res = await getQX_listMonitoring({
                projectId,
            })
            if (res.code == 200 && res.data.length > 0) {
                this.videoList = res.data
                this.bigVideoPic = this.headUrl + res.data[0].coverPicture
                this.videoList.forEach(item => {
                    item.coverPicture = this.headUrl + item.coverPicture
                })
            } else {
                this.videoList = []
            }
        },
        // 视频点击
        videoClick(item) {
            this.$refs.liveVideoDetail.title = item.name
            this.$refs.liveVideoDetail.url = item.videoAddress
            this.$refs.liveVideoDetail.dialogShow = true
        },
        // 获取项目信息
        async getQXprojectInfo(projectId) {
            let res = await getQX_projectInfo({
                projectId,
            })
            if (res.code == 200) {
                this.objData = res.data
            }
        },
        // 获取数据
        async getQXwfQxInfo(projectId) {
            let res = await getQX_wfQxInfo({
                projectId
            })
            if (res.code == 200 && res.data) {
                this.wfQxInfo = res.data
            }
        },
        async getQXmodelInfo() {
            this.query3.deviceId = this.deviceId
            let res = await getQX_modelInfo({
                ...this.query3
            })
            if (res.code == 200) {
                this.modelInfo = res.data.Status
            }
        },
        async getQXcropGrowth(projectId) {
            this.query5.projectId = projectId
            let res = await getQX_cropGrowth({
                ...this.query5
            })
            if (res.code == 200) {
                if (res.data) {
                    this.tendencyList = res.data
                }
            }
        },
        async getQXweatherSoilTrend(projectId) {
            this.query4.projectId = projectId
            let res = await getQX_weatherSoilTrend({
                ...this.query4
            })
            if (res.code == 200) {
                res.data.forEach(item => {
                    this.ghData.push(item.par)
                    this.gzdData.push(item.ioi)
                    this.dqylData.push(item.sap)
                    this.kqwdData.push(item.at)
                    this.kqsdData.push(item.ah)
                    this.ylData.push(item.rf)
                    this.drawEchat()
                    this.trssData.push(item.wp)
                    this.trwdData.push(item.st)
                    this.trsdData.push(item.sm)
                    this.drawEchat3()
                })
            }
        },
        // 绘制echars表
        drawEchat() {
            let chartDom = document.getElementById("right2")
            if (chartDom.hasAttribute("_echarts_instance_")) {
                chartDom.removeAttribute("_echarts_instance_")
            }
            var myChart = echarts.init(chartDom)
            var option
            option = {
                // title: {
                //   text: 'Stacked Line'
                // },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    textStyle: {
                        color: "#fff",
                    },
                    top: 5
                    // data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
                },
                grid: {
                    top: '17%',
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    // feature: {
                    //   saveAsImage: {}
                    // }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: "#fff"
                        }
                    },
                    data: ['04-20', '04-21', '04-22', '04-23', '04-24', '04-25', '04-26', '04-27', '04-28', '04-29']
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "#fff"
                        }
                    },
                },
                series: [
                    {
                        name: '光合有效辐射',
                        type: 'line',
                        smooth: true,
                        stack: 'Total',
                        data: this.ghData
                    },
                    {
                        name: '光照度',
                        type: 'line',
                        smooth: true,
                        stack: 'Total',
                        data: this.gzdData
                    },
                    {
                        name: '大气压力',
                        type: 'line',
                        smooth: true,
                        stack: 'Total',
                        data: this.dqylData
                    },
                    {
                        name: '空气温度',
                        type: 'line',
                        smooth: true,
                        stack: 'Total',
                        data: this.kqwdData
                    },
                    {
                        name: '空气湿度',
                        type: 'line',
                        smooth: true,
                        stack: 'Total',
                        data: this.kqsdData
                    },
                    {
                        name: '雨量',
                        type: 'line',
                        smooth: true,
                        stack: 'Total',
                        data: this.ylData
                    },
                ]
            }
            option && myChart.setOption(option)
        },
        drawEchat3() {
            let chartDom = document.getElementById("right3")
            if (chartDom.hasAttribute("_echarts_instance_")) {
                chartDom.removeAttribute("_echarts_instance_")
            }
            var myChart = echarts.init(chartDom)
            var option
            option = {
                // title: {
                //   text: 'Stacked Line'
                // },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    textStyle: {
                        color: "#fff",
                    },
                    top: 5
                    // data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
                },
                grid: {
                    top: '25%',
                    left: '3%',
                    right: '4%',
                    bottom: '2%',
                    containLabel: true
                },
                toolbox: {
                    // feature: {
                    //   saveAsImage: {}
                    // }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: "#fff"
                        }
                    },
                    data: ['04-20', '04-21', '04-22', '04-23', '04-24', '04-25', '04-26', '04-27', '04-28', '04-29']
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false,
                        lineStyle: {
                            color: "#fff"
                        }
                    },
                },
                series: [
                    {
                        name: '土壤水势',
                        type: 'line',
                        smooth: true,
                        stack: 'Total',
                        data: this.trssData
                    },
                    {
                        name: '土壤温度',
                        type: 'line',
                        smooth: true,
                        stack: 'Total',
                        data: this.trwdData
                    },
                    {
                        name: '土壤湿度',
                        type: 'line',
                        smooth: true,
                        stack: 'Total',
                        data: this.trsdData
                    },
                ]
            }
            option && myChart.setOption(option)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/index.scss';

.main {
    width: 100%;
    height: 100%;
    background: url("../assets/newimgs/zh-bg.png");
    background-size: 100% 100%;
    background-position: center center;

    .main_top {
        width: 100%;
        height: 78px;
        background: url("../assets/newimgs/zh-top.png");
        background-size: 100% 100%;
        background-position: center center;
        display: flex;
        align-items: center;
        justify-content: center;
        // padding-left: 43px;
        // padding-right: 213px;
        // box-sizing: border-box;
        position: relative;

        .t-nam {
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 18px;
            color: #FFFFFF;
            line-height: 23px;
            font-style: normal;
            text-transform: none;
            position: absolute;
            left: 43px;
            display: flex;
            align-items: center;

            img {
                width: 13px;
                height: 8px;
                margin-left: 16px;
            }
        }

        .t-title {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 48px;
            color: #1EE9E9;
            font-style: normal;
            text-transform: none;
            padding-bottom: 6px;
        }

        .t-right {
            display: flex;
            align-items: center;
            position: absolute;
            right: 213px;

            img {
                width: 28px;
                height: 28px;
            }

            .address {
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                font-style: normal;
                text-transform: none;
                margin: 0 10px;
            }

            .feng {
                width: 59px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                background: #1469B8;
                border-radius: 30px 30px 30px 30px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                font-style: normal;
                text-transform: none;
            }
        }
    }

    .count {
        width: 100%;
        height: calc(100vh - 78px);
        // overflow: auto;
        padding: 30px 35px;
        box-sizing: border-box;

        .count-top {
            width: 100%;
            height: 56px;
            display: flex;
            align-items: center;

            .c-left {
                width: 411px;
                height: 56px;
                padding-left: 50px;
                padding-right: 19px;
                padding-bottom: 6px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                background: url("../assets/newimgs/zh-title.png");
                background-size: 100% 100%;
                background-position: center center;
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                font-size: 16px;
                color: #FFFFFF;

                .c-select {
                    flex: 1;
                    width: 100%;
                    height: 30px;
                    line-height: 30px;
                    cursor: pointer;
                    position: relative;

                    .inner-select {
                        position: absolute;
                        left: 0;
                        top: 0;
                    }

                    .ws-name {
                        width: 100%;
                        height: 30px;
                        line-height: 30px;
                        overflow: hidden;
                    }

                    .s-list {
                        .s-item {
                            width: 100%;
                            height: 30px;
                            line-height: 30px;
                            overflow: hidden;
                        }
                    }
                }
            }

            .c-right {
                display: flex;
                align-items: center;
                margin-left: 200px;

                .r-item {
                    width: 193px;
                    height: 65px;
                    text-align: center;
                    padding-top: 20px;
                    background: url("../assets/newimgs/zh-select.png");
                    background-size: 100% 100%;
                    background-position: center center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 600;
                    font-size: 20px;
                    color: #1DE8E9;
                    font-style: normal;
                    text-transform: none;
                    margin-right: 22px;
                    cursor: pointer;
                }

                .active-item {
                    color: #fff;
                }
            }
        }

        .count-count {
            width: 100%;
            height: 910px;
            // height: calc(100vh - 78px - 56px);
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-evenly;
            // justify-content: space-between;
            overflow: auto;

            .c-item {
                width: 493px;
                height: 293px;
                background: url("../assets/newimgs/zh-item.png");
                background-size: 100% 100%;
                background-position: center center;
                padding: 36px 71px 36px 55px;
                box-sizing: border-box;
                // margin-right: 26px;
                margin-bottom: 10px;

                .i-top {
                    display: flex;
                    align-items: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 600;
                    font-size: 20px;
                    color: #1EE9E9;
                    font-style: normal;
                    text-transform: none;

                    img {
                        width: 30px;
                        height: 33px;
                        margin-right: 13px;
                    }
                }

                .i-bottom {
                    display: flex;
                    align-items: center;
                    margin-top: 9px;

                    .img {
                        width: 135px;
                        height: 123px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .i-count {
                        padding-left: 30px;
                        flex: 1;

                        .wendu {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 600;
                            font-size: 32px;
                            color: #FFFFFF;
                            text-align: left;

                            span {
                                font-family: PingFang SC, PingFang SC;
                                font-weight: 600;
                                font-size: 16px;
                                color: #FFFFFF;
                                font-style: normal;
                                text-transform: none;
                                margin-left: 12px;
                            }
                        }

                        .i-title {
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 600;
                            font-size: 16px;
                            color: #FFFFFF;
                            margin-top: 5px;
                            margin-bottom: 10px;
                        }

                        .text {
                            width: 100%;
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            line-height: 23px;
                        }
                    }
                }
            }

            .er-item {
                width: 501px;
                height: 288px;
                background: url("../assets/newimgs/cq-bg.png");
                background-size: 100% 100%;
                background-position: center center;
                padding: 8px 27px 39px 15px;
                box-sizing: border-box;
                margin-bottom: 31px;

                .c-top {
                    width: 100%;
                    height: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .t-left {
                        display: flex;
                        align-items: center;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 600;
                        font-size: 14px;
                        color: #FFFFFF;

                        img {
                            width: 14px;
                            height: 14px;
                            margin-right: 5px;
                        }
                    }
                }

                .c-bottom {
                    width: 100%;
                    height: 230px;
                    margin-top: 18px;

                    .c-b-item {
                        display: flex;
                        align-items: center;
                        margin-bottom: 22px;

                        .sb-title {
                            width: 150px;
                            text-align: right;
                            margin-right: 23px;
                        }

                        .sb-zhi {
                            flex: 1;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }

                    .inner-bottom {
                        width: 100%;
                        height: 230px;
                        display: flex;
                        justify-content: space-around;
                        padding-top: 40px;

                        .zs-item {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: flex-start;

                            .zs-i-img {
                                width: 51px;
                                height: 51px;

                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }

                            .i-time {
                                font-weight: 400;
                                font-size: 12px;
                                color: #E2EFFF;
                                margin: 8px 0;
                            }

                            .i-text {
                                font-weight: 400;
                                font-size: 16px;
                                color: #E2EFFF;
                            }

                            .i-num {
                                font-weight: 400;
                                font-size: 18px;
                                color: #1DE8E9;
                                margin-top: 8px;
                            }
                        }

                        .zs-img {
                            width: 36px;
                            height: 36px;
                            margin-top: 8px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                }
            }

            .item-left,
            .item-right {
                width: 501px;
                height: auto;
                overflow: auto;

                .san-item {
                    padding: 13px 15px;
                    box-sizing: border-box;
                    margin-bottom: 15px;

                    .c-top {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .t-left {
                            display: flex;
                            align-items: center;
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 600;
                            font-size: 14px;
                            color: #FFFFFF;

                            img {
                                width: 14px;
                                height: 14px;
                                margin-right: 5px;
                            }
                        }
                    }

                    .c-bottom {
                        width: 100%;

                        .c-b-item {
                            display: flex;
                            align-items: center;
                            margin-top: 22px;

                            .sb-title {
                                // font-weight: 300;
                                // font-size: 12px;
                                color: #FFFFFF;
                                width: 120px;
                                text-align: right;
                                margin-right: 23px;
                            }

                            .sb-zhi {
                                flex: 1;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                                // font-weight: 300;
                                // font-size: 12px;
                                color: #93D8F9;
                            }
                        }
                    }
                }

                .san1 {
                    width: 501px;
                    height: 342px;
                    background: url("../assets/newimgs/left1.png");
                    background-size: 100% 100%;
                    background-position: center center;
                }

                .san2,
                .san3 {
                    width: 501px;
                    height: 345px;
                    background: url("../assets/newimgs/left1.png");
                    background-size: 100% 100%;
                    background-position: center center;

                    .c-bottom {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-wrap: wrap;
                        padding-left: 24px;
                        margin-top: 28px;

                        .qx-item {
                            display: flex;
                            align-items: center;
                            width: 33%;
                            margin-bottom: 26px;

                            .i-img {
                                width: 28px;
                                height: 25px;
                                margin-right: 12px;

                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }

                            .qx-right {
                                .qx-title {
                                    font-family: PingFang SC, PingFang SC;
                                    font-weight: 600;
                                    font-size: 14px;
                                    color: #FFFFFF;
                                    text-align: left;
                                    font-style: normal;
                                    text-transform: none;
                                }

                                .qx-zhi {
                                    font-family: PingFang SC, PingFang SC;
                                    font-weight: 600;
                                    font-size: 14px;
                                    color: #03A4F2;
                                    margin-top: 5px;
                                }
                            }
                        }
                    }
                }

                .san3 {
                    width: 501px;
                    height: 189px;
                    background: url("../assets/newimgs/left1.png");
                    background-size: 100% 100%;
                    background-position: center center;
                }

                .right1 {
                    width: 501px;
                    height: 202px;
                    background: url("../assets/newimgs/right1.png");
                    background-size: 100% 100%;
                    background-position: center center;

                    .c-bottom {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        padding-top: 3px;
                        padding-left: 34px;

                        .r-c-item {
                            width: 203px;
                            height: 95px;
                            background: url("../assets/newimgs/shuifei/shuju.png");
                            background-size: 100% 100%;
                            background-position: center center;
                            display: flex;
                            align-items: center;

                            .c-i-num {
                                width: 70px;
                                font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
                                font-weight: bold;
                                font-size: 28px;
                                color: #1DE8E9;
                                margin-right: 31px;
                                margin-left: 16px;
                                text-align: center;
                            }

                            .c-i-text {
                                font-family: PingFangSC-Regular, PingFangSC-Regular;
                                font-size: 12px;
                                color: #E2EFFF;
                            }
                        }

                        .r-c-item:nth-child(n + 3) {
                            margin-top: -20px;
                        }
                    }
                }

                .right2 {
                    width: 501px;
                    height: 338px;
                    background: url("../assets/newimgs/right2.png");
                    background-size: 100% 100%;
                    background-position: center center;
                }

                .right3 {
                    width: 501px;
                    height: 333px;
                    background: url("../assets/newimgs/right3.png");
                    background-size: 100% 100%;
                    background-position: center center;
                }
            }

            .item-count {
                flex: 1;
                width: 100%;
                height: 902px;
                background: url("../assets/newimgs/count.png");
                background-size: 100% 100%;
                background-position: center center;
                margin: 0 20px;
                margin-top: -12px;
                padding: 10px;
                box-sizing: border-box;

                .big {
                    position: relative;

                    .big-img {
                        width: 100%;
                        height: 395px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .tip {
                        position: absolute;
                        bottom: 7px;
                        left: 0;
                        width: 98%;

                        width: 100%;
                        height: 61px;
                        background: url("../assets/newimgs/shuifei/tip.png");
                        background-size: 100% 100%;
                        background-position: center center;
                        padding: 0px 26px;
                        // font-size: 20px;
                        // font-family: SourceHanSansSC-regular;
                        // background: rgba($color: #000000, $alpha: 0.7);
                        // border-radius: 15px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        .t-item {
                            height: 20px;
                            line-height: 20px;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .t-img {
                                width: 15px;
                                height: 15px;

                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }

                            .tip-title {
                                font-weight: 500;
                                font-size: 14px;
                                color: #FFFFFF;
                                line-height: 0px;
                                text-align: left;
                                font-style: normal;
                                text-transform: none;
                                margin-left: 3px;
                                margin-right: 14px;
                            }

                            .t-zhi {
                                font-weight: 500;
                                font-size: 14px;
                                color: #03A4F2;
                                line-height: 0px;
                                text-align: left;
                                font-style: normal;
                                text-transform: none;
                            }
                        }
                    }
                }

                .small {
                    max-height: 470px;
                    margin-top: 15px;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    overflow-y: auto;

                    .small_img {
                        width: 32.4%;
                        margin-bottom: 18px;
                        margin-right: 1%;

                        img {
                            width: 100%;
                            height: 128px;
                            margin-bottom: 10px;
                        }

                        .s-item {
                            height: 22px;
                            line-height: 22px;
                            display: flex;
                            align-items: center;

                            .s-left {
                                width: 74px;
                                font-weight: 500;
                                font-size: 14px;
                                color: #FFFFFF;
                                text-align: left;
                            }

                            .s-right {
                                font-weight: 500;
                                font-size: 14px;
                                color: #0395df;
                                text-align: left;
                            }
                        }
                    }

                    .small_img:nth-child(3n) {
                        margin-right: 0;
                    }
                }

                .small::-webkit-scrollbar {
                    width: 0;
                }
            }
        }

        .count-count::-webkit-scrollbar {
            width: 0;
        }
    }

    .count::-webkit-scrollbar {
        width: 0;
    }

    ::v-deep .el-input.el-input--suffix {

        // 修改背景颜色、字体颜色、边框、宽高
        .el-input__inner {
            background: none !important;
            border: none;
            font-weight: 600;
            font-size: 16px;
            color: #FFFFFF;
        }

        // 符号的位置会错乱，进行修正（水平）
        .el-input__suffix-inner {
            // font-weight: 600;
            // font-size: 20px;
            // position: absolute;
            // left: -25px;
        }

        // 符号的位置会错乱，进行修正（垂直）
        .el-select__caret.el-input__icon.el-icon-arrow-up {
            // line-height: 30px;
        }

        .el-input__inner::placeholder {
            // color: red;
        }

        .el-icon-arrow-up:before {
            color: #fff;
            font-weight: 600;
            font-size: 18px;
        }
    }

}
</style>